import { render } from "./ServiciosPage.vue?vue&type=template&id=fde15164"
import script from "./ServiciosPage.vue?vue&type=script&lang=js"
export * from "./ServiciosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__